import { logWorkspace, serviceState } from '../..';
import * as Telecom from '@servicetitan/telecom-rtcs-client';

async function handleQueueDeleted(event: Telecom.QueueDeletedEvent) {
  logWorkspace('service:queue:deleted:' + event.queueName, event);

  serviceState.queues = [
    ...serviceState.queues.filter((q) => q.id !== event.queueId),
  ];
}

export default handleQueueDeleted;
